import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Container from './Container';

const useStyles = makeStyles({
  container: {
    paddingLeft: 13,
    paddingRight: 13,
    paddingTop: 17,
    paddingBottom: 17,
    backgroundColor: 'white',
  },
});

const Main: React.FC = ({ children }) => {
  const classes = useStyles();
  return <Container classes={classes}>{children}</Container>;
};

export default Main;
